var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnreadChatIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52178 9.60865V7.43474H16.337C15.8662 6.82523 15.5331 6.12098 15.3605 5.37043C15.1878 4.61988 15.1798 3.84085 15.337 3.08691H4.35873C3.78218 3.08691 3.22923 3.31595 2.82154 3.72364C2.41386 4.13133 2.18482 4.68427 2.18482 5.26083L2.17395 24.826L6.52178 20.4782H21.7392C22.9348 20.4782 23.9131 19.5 23.9131 18.3043V8.48909C23 9.18474 21.8805 9.60865 20.6522 9.60865H6.52178ZM15.2174 16.1304H6.52178V13.9565H15.2174V16.1304ZM19.5653 12.8695H6.52178V10.6956H19.5653V12.8695Z",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadChatIcon);
export default __webpack_public_path__ + "static/media/unread-chat-icon.dd396b17deddaf67ea38d3be0e0ea8e0.svg";
export { ForwardRef as ReactComponent };